var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('MyHeader',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.getShowHeader),expression:"$store.getters.getShowHeader"}]}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('MyFooter',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.getShowFooter),expression:"$store.getters.getShowFooter"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fc1802a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 9HXb
// module chunks = 2